import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { CommonGridService } from 'src/app/shared/services/common-grid.service';

@Component({
  selector: 'app-diary-day-wise',
  templateUrl: './diary-day-wise.component.html',
  styleUrls: ['./diary-day-wise.component.scss']
})
export class DiaryDayWiseComponent implements OnInit {
  // public gridApiUrl:string = "/diary_user_responses"
  // public type:string = "day"
  constructor(public cgService:CommonGridService,
    public notify:NotifierService) { }
  ngOnInit(): void {
    this.cgService.initCommonGrid();
    this.getDairyDashboardDataDayWise();
    setTimeout(() =>{
      this.getBufferDataForDairy();
    },1000);
    this.cgService.isCellBorder = false;
    this.cgService.isCellTextBold = false;
  }

  getDairyDashboardDataDayWise(){
    let body = {page:this.cgService.page,page_size:this.cgService.page_size,type:'day',survey_id:this.cgService.surveyId};
    this.cgService.getDairyDashboardDataDayWise(body,true);
  }

  applyFilter($event){
    if(this.checkForFilter()){
      this.cgService.page = 1;
      this.cgService.page_size = 20;
      this.cgService.gridDataContainer = [];
      this.cgService.bufferArr = [];
      let body = {
        page:this.cgService.page,
        page_size:this.cgService.page_size,
        survey_id:this.cgService.surveyId,
        filters:this.cgService.appliedFilter,
      }
      if(this.cgService.sortby != ''){
        body['sortby'] = this.cgService.sortby;
      }
      if(this.cgService.serachBy && this.cgService.serachBy.length > 2){
        body['searchBy'] = this.cgService.serachBy;
      }
      body['type'] = 'day';
      this.cgService.getDairyDashboardDataDayWise(body);
      setTimeout(() =>{
        this.getBufferDataForDairy();
      },1000)
    }
  }

  onScroll($event){
    if(this.cgService.page <= this.cgService.gridPageTotal){
      this.cgService.gridDataContainer = [...this.cgService.gridDataContainer,...this.cgService.bufferArr];
      this.cgService.page++;
    }
    this.getBufferDataForDairy(true);
  }

  getBufferDataForDairy(isScroll?){
    if(!isScroll){
      this.cgService.page++;
    }
    let body = {
      page:this.cgService.page,
      page_size:this.cgService.page_size,
      type: 'day',
      survey_id:this.cgService.surveyId
    };
    let page = this.cgService.page;
    if(page <= this.cgService.gridPageTotal){
      this.gridApiRequest(body,false,true);
    }
  }

  gridApiRequest(body,isDownload?,isbuffer?){
    if(this.cgService.sortby != ''){
      body['sortby'] = this.cgService.sortby;
      body['order'] = this.cgService.sortOrder;
    }
    if(this.cgService.serachBy && this.cgService.serachBy.length > 2){
      body['searchBy'] = this.cgService.serachBy;
    }
    if(this.checkForFilter()){
      body['filters'] = this.cgService.appliedFilter;
    }
    body['type'] = 'day';
    if(isDownload){
      this.cgService.jsonToCsvDownload(body,'Dairy-day');
    }else{
      this.cgService.getDairyDashboardDataDayWise(body,false,isbuffer);
    }
  }

  checkForFilter(){
    if(Object.keys(this.cgService.appliedFilter).length){
      let isDateValid = true;
      Object.keys(this.cgService.appliedFilter).forEach(key =>{
        if(!this.cgService.appliedFilter[key].length){
          delete this.cgService.appliedFilter[key];
        }
        if(key === 'date'){
          if(this.cgService.appliedFilter[key]){
            this.cgService.appliedFilter[key].forEach(va =>{
              if(!va){
                this.notify.notify('error','Please Select Start or End Date');
                isDateValid = false;
                return;
              }
            })
          }
        }
      })
      return Object.keys(this.cgService.appliedFilter).length && isDateValid ? true : false;
    }else{
      return false;
    }
  }

  gridSorting($event){
    if(!this.cgService.sortingDeatils[$event.key]){
      this.cgService.sortingDeatils = {}
      this.cgService.sortingDeatils[$event.key] = true;
    }else{
      this.cgService.sortingDeatils[$event.key] = !this.cgService.sortingDeatils[$event.key];
    }
    this.cgService.sortby = $event.key;
    this.cgService.sortOrder = $event.order;
    this.cgService.gridDataContainer = [];
    this.cgService.bufferArr = [];
    this.cgService.page = 1;
    this.cgService.page_size = 20;
    let body = {page:this.cgService.page,page_size:this.cgService.page_size,survey_id:this.cgService.surveyId,sortby:this.cgService.sortby,order:this.cgService.sortOrder};
    this.gridApiRequest(body);
    setTimeout(() =>{
      this.getBufferDataForDairy();
    },1000)
  }

  onSearchChange($event){
    if($event.str.length > 2){
      this.cgService.serachBy = $event.str
      this.cgService.gridDataContainer = [];
      this.cgService.bufferArr = [];
      this.cgService.page = 1;
      this.cgService.page_size = 20;
      let body = {page:this.cgService.page,page_size:this.cgService.page_size,survey_id:this.cgService.surveyId};
      this.gridApiRequest(body);
    }else{
      this.cgService.serachBy = $event.str
      this.cgService.gridDataContainer = [];
      this.cgService.bufferArr = [];
      this.cgService.page = 1;
      this.cgService.page_size = 20;
      let body = {page:this.cgService.page,page_size:this.cgService.page_size,survey_id:this.cgService.surveyId};
      this.gridApiRequest(body);
    }
    setTimeout(() =>{
      this.getBufferDataForDairy();
    },1000)
  }

  downloadGridData(){
    let body = {survey_id:this.cgService.surveyId,no_pagination:true}
    this.gridApiRequest(body,true);
  }
}
